import { Reorder, useDragControls } from "framer-motion";
import { GripVertical } from "lucide-react";
import { Checkbox } from "@/components/ui/checkbox";

const Row = ({ id, label, checked, onToggle, prefix, position }) => {
  const controls = useDragControls();
  return (
    <Reorder.Item
      value={id}
      dragListener={false}
      dragControls={controls}
      className={`flex items-center gap-3 rounded-md border px-3 py-2 bg-card select-none ${
        checked ? "border-border" : "border-dashed border-border/60 opacity-60"
      }`}
      data-testid={`col-${prefix}-${id}`}
    >
      <button
        type="button"
        onPointerDown={(e) => { e.preventDefault(); controls.start(e); }}
        className="cursor-grab active:cursor-grabbing touch-none text-muted-foreground hover:text-foreground"
        aria-label={`Drag ${label}`}
        data-testid={`col-${prefix}-${id}-handle`}
      >
        <GripVertical className="w-4 h-4" />
      </button>
      <Checkbox checked={checked} onCheckedChange={onToggle} data-testid={`col-${prefix}-${id}-checkbox`} />
      <span className="text-sm flex-1">{label}</span>
      {checked && <span className="text-[11px] font-mono text-muted-foreground">#{position}</span>}
    </Reorder.Item>
  );
};

export const ColumnOrderList = ({ available, selected, onChange, prefix }) => {
  const order = [...selected.filter((k) => k in available),
    ...Object.keys(available).filter((k) => !selected.includes(k))];
  const handleReorder = (next) => onChange(next.filter((k) => selected.includes(k)));
  const toggle = (k) => onChange(selected.includes(k) ? selected.filter((c) => c !== k) : [...selected, k]);
  return (
    <Reorder.Group axis="y" values={order} onReorder={handleReorder}
                   className="space-y-1.5 mt-2 max-w-md" data-testid={`col-order-${prefix}`}>
      {order.map((k) => (
        <Row key={k} id={k} label={available[k]} checked={selected.includes(k)}
             onToggle={() => toggle(k)} prefix={prefix} position={selected.indexOf(k) + 1} />
      ))}
    </Reorder.Group>
  );
};
